import AppRoutes from "AppRoutes";
import { DisplayFileSize } from "components/DisplayFields/DisplayFileSize";
import { InlineSpinner } from "components/InlineSpinner";
import { GeneratedDocument } from "models/GeneratedDocument";
import { useApi, useTranslations } from "providers";
import React from "react";

interface OutputDocumentsContentProps {
  isLoading: boolean;
  documents: GeneratedDocument[] | undefined;
  onOpenImmediately: (url: string) => void;
}

export const OutputDocumentsContent: React.FC<OutputDocumentsContentProps> = ({
  isLoading,
  documents,
  onOpenImmediately,
}) => {
  const i18n = useTranslations();
  const { downloadApi } = useApi();

  if (isLoading) {
    return <InlineSpinner text={i18n.OutputDocuments_Loading} />;
  }

  return (
    <table className="table sbb-table-bs">
      <thead>
        <tr>
          <th />
          <th>{i18n.OutputDocuments_Table_Name}</th>
          <th>{i18n.OutputDocuments_Table_Size}</th>
        </tr>
      </thead>
      <tbody>
        {documents ? (
          documents.map((document, index) => {
            const { url, fileSize, fileName, iconClass, openImmediately: shouldOpenImmediately } = document;
            const absoluteUrl = AppRoutes.getBackendUrl(url || "");

            const key = `outputdocuments-panel-${index}`;
            if (shouldOpenImmediately && url) {
              onOpenImmediately(url);
            }

            return (
              <tr key={key}>
                <td className="icon">{iconClass ? <i className={`file-icon ${iconClass}`} /> : null}</td>
                <td className="document">
                  <a
                    key={fileName}
                    className="btn-link btn-link-underline"
                    onClick={(e) => {
                      e.preventDefault();
                      downloadApi.handleDownload(absoluteUrl);
                    }}
                  >
                    {fileName}
                  </a>
                </td>
                <td className="file-size">
                  <DisplayFileSize value={fileSize} />
                </td>
              </tr>
            );
          })
        ) : (
          <tr className="is-empty">
            <td className="message" colSpan={2}>
              {i18n.OutputDocuments_Empty}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
